import { render } from "./AdmCreateClubinho.vue?vue&type=template&id=7cfa05e4&scoped=true&ts=true"
import script from "./AdmCreateClubinho.vue?vue&type=script&lang=ts"
export * from "./AdmCreateClubinho.vue?vue&type=script&lang=ts"

import "./AdmCreateClubinho.vue?vue&type=style&index=0&id=7cfa05e4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cfa05e4"]])

export default __exports__